import { render, staticRenderFns } from "./alarmComplaint.vue?vue&type=template&id=947e44aa&scoped=true"
import script from "./alarmComplaint.vue?vue&type=script&lang=js"
export * from "./alarmComplaint.vue?vue&type=script&lang=js"
import style0 from "./alarmComplaint.vue?vue&type=style&index=0&id=947e44aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947e44aa",
  null
  
)

export default component.exports